import Dinero from 'dinero.js'
import json_data from '../../../data_service.json'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconPencil from '@/components/icons/pencil.vue'
import IconCustomerSupport from '@/components/icons/customerSupport.vue'
import IconInformation from '@/components/icons/information.vue'
import Axios from "axios"


export default {
    name: 'ServicePremium',
    props: ['EditStatus'],
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack,
        IconStarCheck,
        IconPencil,
        IconCheck,
        IconCustomerSupport,
        IconInformation
    },
    data() {
        return {
            premium_data: '',
            payment_type: '',
            yearly_data: '',
            is_uw_gst: '',
            small_business_nsw: '',
            datas: json_data,
            state_name: '',
            breakdown: '',
            declarations: '',
            previous_claims: '',
            outstanding_claims: '',
            previous_policy: '',
            package_code: '',
            additional_branches: 0,
            educator_id:'',

            //PR
            pr_base_premium: '',
            pr_uw_gst: '',
            pr_fdca_fee: '',
            pr_fdca_gst: '',
            pr_stamp_duty: '',
            pr_sub_total: '',

      

            //Additional Branches
            ab_base_premium: '',
            ab_uw_gst: '',
            ab_fdca_fee: '',
            ab_fdca_gst: '',
            ab_stamp_duty: '',
            ab_sub_total: '',


            //membership
            membership_fee: '',

            total_amount: '',
            disabled: ''

        }
    },
    watch: {
        EditStatus: function(newVal, oldVal) {
            if (newVal == true) {
                var x = document.getElementById("sidebar_main_container");
                x.classList.add("full_width_container");
                x.classList.add("block")
            } else {
                var x = document.getElementById("sidebar_main_container");
                x.classList.remove("full_width_container");
                x.classList.remove("block");
            }
        }
    },
    mounted() {
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
        //Add to POS
        this.AddToDB();

        this.$parent.ValidateProgressEntry("ServiceInsuranceProcess");
        this.ValidateSessionData();
        
       
        
        this.$parent.CheckWindowPathName();
        this.package_code = "Public Liability - Package Rate";
        this.personal_info = this.$parent.ServiceInsuranceProcess.rep_first_name + ' ' + this.$parent.ServiceInsuranceProcess.rep_last_name;
        this.address = '';


        // this.$parent.mailing_unit_number + ' ' + this.$parent.mailing_street_number + ' ' + this.$parent.mailing_suburb + ' ' + this.$parent.mailing_street_number + ' ' + this.$parent.mailing_postcode;
        this.previous_claims = this.TextForSidebar(this.$parent.ServiceInsuranceProcess.previous_claims) + 'previous claims';
        this.outstanding_claims = this.TextForSidebar(this.$parent.ServiceInsuranceProcess.outstanding_claims) + 'outstanding claims';
        this.previous_policy = this.TextForSidebar(this.$parent.ServiceInsuranceProcess.previous_policies) + 'previous policy infringement';
        var declarations_arr = [this.$parent.ServiceInsuranceProcess.previous_claims, this.$parent.ServiceInsuranceProcess.outstanding_claims, this.$parent.ServiceInsuranceProcess.previous_policies];
        this.declarations = this.CheckDeclarations(declarations_arr);

        // if(this.declarations == false){
        // this.$parent.EnableNextButton();
        // }else{
        // this.$parent.DisableNextButton();
        // }

        //should fetch from session
        //example
        // var package_id_session = this.$parent.ServiceInsuranceProcess.package_id;
        // this.is_uw_gst = this.$parent.ServiceInsuranceProcess.registered_for_gst;
        // this.small_business_nsw = this.$parent.ServiceInsuranceProcess.small_business_disclaimer;
        this.datas = json_data;
        //this.state_name = (this.$parent.ServiceInsuranceProcess.state).toLowerCase();


        //for testing
        // var package_id_session = "3bf126c2-1173-481c-832d-65032f12390a";

        // this.is_uw_gst = false;
        // this.small_business_nsw = false;
        // this.state_name = "nsw";
        // var additional_branches = 1;

        var package_id_session = "3bf126c2-1173-481c-832d-65032f12390a";
        // this.educator_id = this.$parent.ServiceInsuranceProcess.educator_id;
        // this.is_uw_gst = false;
        // this.small_business_nsw = false;
        // this.state_name = "nsw";

        if(this.additional_branches == 0){
            var y = document.getElementById("flexme");
            y.classList.remove("md6");
            y.classList.add("md12");
            y.classList.remove("lg6");
            y.classList.add("lg12");
            y.classList.remove("xl6");
            y.classList.add("xl12");
        }
        

        // PARENT PACKAGE
        var package_id = this.GetPackageDetailsByPackageId(package_id_session);
        var number_of_educators = this.GetNumberOfEducators(this.educator_id);
        
        var base_premium_obj = this.GetBasePremium(package_id, this.educator_id);
        var base_premium = base_premium_obj.base_premium;
        var state_code = this.GetState(this.state_name);
        var stamp_duty_percentage = this.GetStampDuty(state_code);
        var computed_stamp = this.GetComputedStampFee(base_premium_obj, stamp_duty_percentage);
        var sub_total= this.GetSubTotal(base_premium_obj, computed_stamp);

        //Package rate breakdown display on front end
        this.pr_base_premium = this.DineroPrecisionWrapper(base_premium_obj[0].base_premium).toFixed(2);
        this.pr_uw_gst = this.DineroPrecisionWrapper(base_premium_obj[0].uw_gst).toFixed(2);
        this.pr_fdca_fee = this.DineroPrecisionWrapper(base_premium_obj[0].fdca_fee).toFixed(2);
        this.pr_fdca_gst = this.DineroPrecisionWrapper(base_premium_obj[0].fdca_gst).toFixed(2);
        this.pr_stamp_duty = this.DineroPrecisionWrapper(computed_stamp).toFixed(2);
        this.pr_sub_total = this.DineroPrecisionWrapper(sub_total).toFixed(2);

        //compute additional branches
    
        var ab_sub_total_final = this.AdditionalBranches(this.additional_branches, base_premium_obj);

        //MEMBERSHIP
        var membership_fee = this.GetMembershipFee(package_id);
        var total_amount = this.GetTotalAmount(sub_total,  ab_sub_total_final, membership_fee);
        this.membership_fee = this.DineroPrecisionWrapper(membership_fee).toFixed(2);
        this.yearly_data = total_amount;
        this.premium_data =  this.yearly_data.toFixed(2);
        this.total_amount = total_amount.toFixed(2);
        this.payment_type = 'year';
        this.breakdown = 'Total amount payable: $' +  this.yearly_data.toFixed(2);
    },
    methods: {
        UpdateHeader() {
            this.$parent.EditStatus = false;
        },
        TextForSidebar(params) {
            if (params) {
                return 'Has ';
            } else {
                return 'No ';
            }
        },
        CheckDeclarations(declarations_arr) {
            var counter = 0;
            for (var i = 0; i < declarations_arr.length; i++) {
                if (declarations_arr[i] == true) {
                    counter++;
                }
            }

            if (counter > 0) {
                return true;
            } else {
                return false;
            }
        },
        GetPackageDetailsByPackageId(package_id) {
            var packages = this.datas.service.package;
            var find_by_package_id = (packages.filter(p => p.id == package_id));
            var package_id = find_by_package_id[0].id;
            return package_id;
        },
        GetNumberOfEducators(educator_id){
            var educators = this.datas.service.educator;
            var find_by_educator_id = (educators.filter(e => e.id == educator_id));
            var number_of_educators = find_by_educator_id[0].number_of_educators;
            return number_of_educators;
        },
        GetBasePremium(package_id, educator_id) {
            var base_premium_data_ = this.datas.service.base_premium;
            var find_base_premium_ = (base_premium_data_.filter(function(bp) {
                return bp.package_id == package_id && bp.educator_id == educator_id;
            }));
            var _base_premium = find_base_premium_[0].base_premium;
            var update_uw_gst = this.CheckGst(this.is_uw_gst, _base_premium);
            find_base_premium_[0]['uw_gst'] = update_uw_gst;
            return find_base_premium_;
        },
        CheckGst(is_uw_gst, base_premium_data_) {
            //uw gst is true remove GST amount
            if (is_uw_gst) {
                return 0;
            } else {
                var uw_gst = Dinero({ amount: base_premium_data_ }).percentage(10).getAmount();
                return this.DineroMoneyWrapper(uw_gst);
            }
        },
        DineroMoneyWrapper(number) {
            var two_decimals = Dinero({
                amount: number
            }).getAmount();
            return two_decimals;
        },
        GetState(state_name) {
            var state = this.datas.service.states;
            if(state_name){
                state_name = state_name.toLowerCase();
            }
            var state_data = (state.filter(s => s.state_name == state_name));
            var group_state = state_data[0].group_state;
            return group_state;
        },
        GetStampDuty(group_state) {
            var _state = (this.$parent.ServiceInsuranceProcess.state).toLowerCase();
            if (_state == 'nsw' && this.$parent.ServiceInsuranceProcess.small_business_disclaimer ) {
                return 0;
            }
            var stamp_data = this.datas.service.stamp;
            var find_stamp = (stamp_data.filter(s => s.group_state == group_state));
            var stamp_fee_data = find_stamp[0].stamp_fee;
            return stamp_fee_data;
        },
        GetComputedStampFee(base_premium_data, stamp_fee_percentage) {

            var base_premium = base_premium_data[0].base_premium;
            var uw_gst = base_premium_data[0].uw_gst;
            var base_premium_uw_gst = Dinero({amount: base_premium}).add(Dinero({amount: uw_gst})).getAmount();
            var base_premium_uw_gst_ = Dinero({
                amount: base_premium_uw_gst,
                currency: 'AUD',
                precision: 2
            }).toUnit();
           
            var total_stamp_fee = base_premium_uw_gst_ * stamp_fee_percentage;
            var total = Math.round(total_stamp_fee);
            return total;
        },
         GetSubTotal(base_premium_obj, computed_stamp_duty) {
            var base_premium = base_premium_obj[0].base_premium ? this.DineroMoneyWrapper(base_premium_obj[0].base_premium) : 0;
            var fdca_fee = base_premium_obj[0].fdca_fee ? this.DineroMoneyWrapper(base_premium_obj[0].fdca_fee) : 0;
            var fdca_gst = base_premium_obj[0].fdca_gst ? this.DineroMoneyWrapper(base_premium_obj[0].fdca_gst) : 0;
            var uw_gst = base_premium_obj[0].uw_gst? this.DineroMoneyWrapper(base_premium_obj[0].uw_gst): 0;
            var stamp_fee = this.DineroMoneyWrapper(computed_stamp_duty);
            var package_sub_total = Dinero({
                amount: base_premium
            }).add(Dinero({
                amount: fdca_fee
            })).add(Dinero({
                amount: fdca_gst
            })).add(Dinero({
                amount: uw_gst
            })).add(Dinero({
                amount: stamp_fee
            })).getAmount();
            return package_sub_total;
        },
        GetTotalAmount(sub_total, ab_sub_total_final, membership_fee) {
            var sub_total = this.DineroMoneyWrapper(sub_total);
            var ab_sub_total_final = this.DineroMoneyWrapper(ab_sub_total_final);
            var membership_fee_ = this.DineroMoneyWrapper(membership_fee);

            var total_amount = Dinero({
                amount: sub_total
            }).add(Dinero({
                amount: ab_sub_total_final
            })).add(Dinero({
                amount: membership_fee_
            })).getAmount();
            var total_amount_ = Dinero({
                amount: total_amount,
                currency: 'AUD',
                precision: 2
            }).toUnit();
            return total_amount_;
        },
        GetMembershipFee(package_id) {
            var membership_data = this.datas.service.membership;
            var membership_data_ = (membership_data.filter(md => md.package_id.indexOf(package_id) >= 0));
            var membership_fee = membership_data_[0].membership_fee;
            return membership_fee
        },
        DineroPrecisionWrapper(number) {
            return Dinero({
                amount: number,
                currency: 'AUD',
                precision: 2
            }).toUnit();
        },
        //Toggles for monthly, fotrnightly, yearly
        ToggleSelected(params) {
            this.$parent.RemoveClassFrom('choice', 'default');
            if (params == 'yearly') {
                this.premium_data = this.yearly_data.toFixed(2);
                this.payment_type = 'year';
                this.breakdown = 'Total amount payable: $' +  this.yearly_data.toFixed(2);
                document.getElementById('choice1').classList.add("default");
            } else if (params == 'monthly') {
                this.premium_data = this.ComputePaymentPlan('monthly', this.yearly_data).toFixed(2);
                this.payment_type = 'month';
                document.getElementById('choice2').classList.add("default");
            } else {
                //fortnight
                this.premium_data = this.ComputePaymentPlan('fortnight', this.yearly_data).toFixed(2);
                this.payment_type = 'fortnight';
                document.getElementById('choice3').classList.add("default");
            }
        },
        ComputePaymentPlan(payment_plan, total_amount) {
            var interest = 0.1;
            var new_total_payable = total_amount + (total_amount * interest);
            var monthly = new_total_payable / 12;
            var two_months = monthly * 2;
            var ten_months = monthly * 10;
            var payment_plan_months = this.GetMonths(payment_plan);
            var payment_plan_amount = (new_total_payable - two_months) / payment_plan_months;
            var payment_plan_amount_ = parseFloat(payment_plan_amount).toFixed(2);
            var convert_to_int = Dinero({
                amount: 10000
            }).multiply(payment_plan_amount_).toUnit();
            var total = Dinero({
                amount: convert_to_int,
                currency: 'AUD',
                precision: 2
            }).toUnit();
            this.UpdateBreakdown(total, monthly, two_months, new_total_payable, payment_plan);
            return total;
        },
        GetMonths(payment_plan) {
            if (payment_plan == 'fortnight') {
                return 20;
            } else {
                return 10;
            }
        },
        //This is the breakdown when you click the toggle for monthly/fortnightly
        UpdateBreakdown(total, monthly, two_months, new_total_payable, payment_plan) {
            if (payment_plan == 'monthly') {
                this.breakdown = '2x monthly payments of $' + parseFloat(two_months).toFixed(2) + ' followed by 10x monthly payments of $' + parseFloat(total).toFixed(2) + '. Total amount payable: $' + parseFloat(new_total_payable).toFixed(2);
            } else {
                this.breakdown = '2x monthly payments of $' + parseFloat(two_months).toFixed(2) + ' followed by 20x forthnightly payments of $' + parseFloat(total).toFixed(2) + '. Total amount payable: $' + parseFloat(new_total_payable).toFixed(2);
            }
        },
        AdditionalBranches(_additionalBranches, _base_premium_obj){
            if(_additionalBranches == 0){
                return 0;
            }else{
                return this.AdditionalBranchesCompute(_additionalBranches, _base_premium_obj);
            }
        },
        AdditionalBranchesCallFunctionToCompute(index, _base_premium_obj){
            var additional_branches = this.datas.service.additional_branches;
            var membership_data_ = (additional_branches.filter(ab => ab.branches_added.indexOf(index) >= 0));
            var percentage = membership_data_[0].percentage;
            var base_premium = Dinero({ amount: _base_premium_obj[0].base_premium  }).percentage(percentage).getAmount();
            var update_uw_gst = this.CheckGst(this.is_uw_gst, base_premium);
            var fdca_fee = parseInt(membership_data_[0].fdca_fee);
            var fdca_gst = Dinero({ amount: parseInt(fdca_fee)  }).percentage(10).getAmount();    
            var new_base_premium = [{"base_premium" : base_premium, "uw_gst":update_uw_gst, "fdca_fee": fdca_fee, "fdca_gst": fdca_gst}];
            var state_code = this.GetState(this.$parent.ServiceInsuranceProcess.ab_add_state);
            var stamp_duty_percentage = this.GetStampDuty(state_code);
            var computed_stamp = this.GetComputedStampFee(new_base_premium, stamp_duty_percentage);
            var sub_total= this.GetSubTotal(new_base_premium, computed_stamp);

            return [{"base_premium" : base_premium, "uw_gst":update_uw_gst, "fdca_fee": fdca_fee, "fdca_gst": fdca_gst, "sub_total": sub_total, "computed_stamp": computed_stamp}];
        },
        AdditionalBranchesCompute(_additionalBranches, _base_premium_obj){
            var base_premium_temp = 0;
            var fdca_fee_temp = 0;
            var fdca_gst_temp = 0;
            var uw_gst_temp = 0;
            var stamp_duty_temp = 0;
            var sub_total_temp = 0;
            
            //iterate on how many is the branches are/is.
            for(var i=0;i<_additionalBranches;i++){
                var temp_ = i + 1;
                var datas = this.AdditionalBranchesCallFunctionToCompute(temp_, _base_premium_obj);
                base_premium_temp = Dinero({amount: base_premium_temp}).add(Dinero({amount: datas[0].base_premium})).getAmount(); 
                fdca_fee_temp = Dinero({amount: fdca_fee_temp}).add(Dinero({amount: datas[0].fdca_fee})).getAmount(); 
                fdca_gst_temp = Dinero({amount: fdca_gst_temp}).add(Dinero({amount: datas[0].fdca_gst})).getAmount(); 
                uw_gst_temp = Dinero({amount: uw_gst_temp}).add(Dinero({amount: datas[0].uw_gst})).getAmount();
                sub_total_temp = Dinero({amount: sub_total_temp}).add(Dinero({amount: datas[0].sub_total})).getAmount();
                stamp_duty_temp = Dinero({amount: stamp_duty_temp}).add(Dinero({amount: datas[0].computed_stamp})).getAmount(); 
            }
            this.ab_base_premium = (this.DineroPrecisionWrapper(base_premium_temp)).toFixed(2);
            this.ab_uw_gst = (this.DineroPrecisionWrapper(uw_gst_temp)).toFixed(2); 
            this.ab_fdca_fee = (this.DineroPrecisionWrapper(fdca_fee_temp)).toFixed(2);
            this.ab_fdca_gst = (this.DineroPrecisionWrapper(fdca_gst_temp)).toFixed(2);
            this.ab_stamp_duty = (this.DineroPrecisionWrapper(stamp_duty_temp)).toFixed(2);
            this.ab_sub_total = (this.DineroPrecisionWrapper(sub_total_temp)).toFixed(2);
            return sub_total_temp;
        },
        Edit() {
            this.$parent.EditStatus = true;
        },
        Next() {
            this.$parent.ServiceNextStep(-1,"ServiceAddOn");
            this.$parent.EditStatus = false;
        },
        
        ValidateSessionData(){
            this.educator_id = this.$parent.ServiceInsuranceProcess.educator_id;
            this.is_uw_gst =  this.$parent.ServiceInsuranceProcess.registered_for_gst;
            this.small_business_nsw = this.$parent.ServiceInsuranceProcess.small_business_disclaimer;
            this.state_name = this.$parent.ServiceInsuranceProcess.state;
            if(this.$parent.ServiceInsuranceProcess.additional_branches){
                this.additional_branches = this.$parent.ServiceInsuranceProcess.additional_branches_count;
            }
        },
        AddToDB(){
            let educator = this.$parent.ServiceInsuranceProcess;
            let birthdate = undefined;
            if(educator.birth_year != ''){
                birthdate = educator.birth_year+'-'+educator.birth_month.text+'-'+educator.birth_day;
            }

            //add 1 to the month of expiry date/created date because in javascript January starts in 0
            var d = new Date();
            var created_date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            var expiry_date = new Date();
            expiry_date.setDate(d.getDate()+30);
            var expiry_date_ = expiry_date.getFullYear() + '-' + (expiry_date.getMonth() + 1) + '-' + expiry_date.getDate();
            var commencement_date = new Date(educator.commencement_date);
            var commencement_date_ = commencement_date.getFullYear() + '-' + (commencement_date.getMonth() + 2) + '-' + commencement_date.getDate();



            const formdata = {
                data: JSON.stringify(this.$parent.ServiceInsuranceProcess),
                birthdate: birthdate,
                email_address: educator.email_address,
                quote_ref_num: this.$parent.ServiceInsuranceProcess.quote_ref_num,
                is_deleted: "false",
                date_expiry : expiry_date_

            }

            let CheckSessionByReferenceNumber_ = this.$parent.CheckSessionByReferenceNumber(this.$parent.ServiceInsuranceProcess.quote_ref_num);

            // FIRST check if reference number is already in POS
            //if not yet existing  
            CheckSessionByReferenceNumber_.then(response => {
                if(response.data.customizations.results.length == 0){

                    let AddSession_ = this.$parent.AddSession(formdata);
                    
                    AddSession_.then(function (response) {
                        var db_session = response.data.customizations.results[0];
                        this.$parent.session_id = db_session.id;
                    })
                    .catch(function (response) { 
                        console.error("Check Session By Reference Number", response);
                    });
                }else{
                    
                }
            })
            .catch(response => { 
                console.error("Check Session By Reference Number", response);
            });

        },
        OpenModal(){
            this.$parent.active_modal = 2;
        }
    }
} 